module.exports = __webpack_public_path__ + "media/landing_work/home/images/others-7a812fbb40d00d25250947ff66cbeb66.svg";